<template>
  <Card :btnMsg="$t('showGiftCard.btn_text')" @changeStep="changeStep">
    <div class="card-showGiftCard">
      <div class="card-content">
        <p class="card-title" v-html="$t('showGiftCard.title')"></p>
        <div class="card-text" v-html="$t('showGiftCard.text')"></div>
        <div class="gift-card-box">
          <span class="gift-card-box-text">{{ $t('showGiftCard.gift_card_text') }}</span>
          <div class="gift-card-box-pic card-swipe">
            <!-- 轮播图部分 -->
            <van-swipe ref="mySwipe" @change="changeSwipeIdx" indicator-color="#f4a300">
              <van-swipe-item v-for="item in form.default_channels" :key="item.id">
                <img :src="item.channel_pic" alt="Gift" class="card-image" />
              </van-swipe-item>
            </van-swipe>
            <!-- 左右箭头 -->
            <van-button class="swipe-arrow prev-arrow" @click="prev">
              <van-icon class="arrow" name="arrow-left" />
            </van-button>
            <van-button class="swipe-arrow next-arrow" @click="next">
              <van-icon class="arrow" name="arrow" />
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      currentIndex: 0,
      giftCard: require('@/assets/gift-card.png'),
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    changeStep() {
      let item = this.form.default_channels[this.currentIndex];
      this.form.channel_pic = item.channel_pic;
      this.form.default_channel_id = item.id;
      this.form.default_channel_type = item.channel_type;
      this.$parent.changeStep('star',this.form);
    },
    prev() {
      this.$refs.mySwipe.prev();
    },
    next() {
      this.$refs.mySwipe.next();
    },
    changeSwipeIdx(v) {
      this.currentIndex = v;
    },
  },
};
</script>

<style lang="scss">
.card-showGiftCard {
  position: relative;
  width: 100%;
  .card-title {
    font-size: 24px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-text {
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .gift-card-box {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: linear-gradient(180deg, #ffd814aa, #ffa031aa);
    border-radius: 10px;
    border: 2px solid #ffd814aa;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    .gift-card-box-pic {
      img {
        width: 100%;
      }
    }
    .gift-card-box-text {
      font-size: 22px;
      font-weight: 500;
      text-align: center;
    }
  }
  .card-swipe {
    position: relative;
    border-radius: 8px;
    .van-swipe {
      border-radius: 8px;
    }
  }
  .van-swipe__indicators {
    bottom: 20px;
  }
  .swipe-arrow {
    width: 28px;
    border: none;
    height: 28px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #000;
    font-size: 24px;
    background-color: #ffd814;
    padding: 0;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    border-radius: 2px;
  }

  .prev-arrow {
    left: 6px;
  }

  .next-arrow {
    right: 6px;
  }
  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
  .van-swipe__track {
    display: flex;
    align-items: center;
  }
  .van-swipe {
    border: 1px solid #f4a300;
    // background: linear-gradient(180deg, rgba(245, 200, 0, 0.6666666667), #ffa031);
    background: #fff;
  }
}
</style>
